export const PORTFOLIO_IMPORT_SYNC_FAILURE_MESSAGE =
    'Actual portfolio was saved, but Position Sizing could not be synced. Use Sync Draft to retry.';

export function portfolioImportPostApplyErrorMessage(error) {
    const message = error?.message;
    return typeof message === 'string' && message.startsWith('Actual portfolio ')
        ? message
        : PORTFOLIO_IMPORT_SYNC_FAILURE_MESSAGE;
}

// Listeners register their work synchronously, so Apply callers can wait for
// dependent portfolio publication before dismissing the review.
export async function dispatchPortfolioImportApplied(detail = {}) {
    const completions = [];
    window.dispatchEvent(new CustomEvent('portfolio-import-applied', {
        detail: {
            ...detail,
            waitUntil: (completion) => completions.push(Promise.resolve(completion)),
        },
    }));
    if (completions.length === 0) {
        throw new Error(PORTFOLIO_IMPORT_SYNC_FAILURE_MESSAGE);
    }
    try {
        await Promise.all(completions);
    } catch (error) {
        throw new Error(portfolioImportPostApplyErrorMessage(error), { cause: error });
    }
}
